import React from "react";
// AppFrame removed: route-level layout wraps admin pages
import { UsageManagementTab } from "../../components/Admin/UsageManagementTab";

export const AdminUsagePage = () => {
  return (
      <div className="container mx-auto py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold">
            Admin Dashboard - Usage Management
          </h1>
          <p className="mt-2 text-muted-foreground">
            Manage user usage limits and reset counters as needed.
          </p>
        </div>

        <UsageManagementTab />
      </div>
  );
};

export default AdminUsagePage;
